import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

import { addressFormFields } from './addressFieldsForm';

const formFields = [
  ...addressFormFields,
  {
    name: 'isDeedRestricted',
    label: 'Deed Restricted',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'deedRestrictionType',
    label: 'Deed Restriction Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'deedRestrictionMonths',
    label: 'Deed Restriction Months',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isNewConstruction',
    label: 'New Construction',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'appraisedValue',
    label: 'Appraised Value',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'occupancy',
    label: 'Occupancy',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isRelocationLoan',
    label: 'Relocation Loan',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isShortTermRental',
    label: 'Short-Term Rental',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isCondotel',
    label: 'Condotel',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'locationType',
    label: 'Location',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'propertyRightsEstateHeld',
    label: 'Property Rights Estate Held',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'leaseholdExpiration',
    label: 'Leasehold Expiration',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'propertyType',
    label: 'Property Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'numberOfUnits',
    label: 'Number Of Units',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'attachmentType',
    label: 'Attachment Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'propertyValue',
    label: 'Purchase Price',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'totalSalesConcessionAmount',
    label: 'Seller Concessions',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'status',
    label: 'Property Status',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'manufacturedHomeType',
    label: 'Manufactured Home Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'completionDate',
    label: 'Completion Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const propertyAddressForm = {
  name: FormNames.PROPERTY_ADDRESS,
  label: 'Property Address',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
